import {
  Activity,
  MessageCircle,
  Heart,
  Users,
  FileText,
  Folder,
  Image,
  Video,
  Music,
  Calendar,
  Tag,
  Bookmark,
  Star,
  List,
  LayoutGrid,
  BookOpen,
  Newspaper,
  Mail,
  Link as LinkIcon,
  MapPin,
  Package,
  ShoppingCart,
  Database,
  Table2,
  type LucideIcon,
} from 'lucide-react';

// ponytail: static map, not lucide-react/dynamic. DynamicIcon IS supported here
// but loads each icon async (useEffect -> null until resolved = icon flash) and
// pulls the full ~1600-icon dynamic-import graph into the build. A synchronous,
// tree-shaken map covering the known names + common content icons is calmer and
// smaller; extend the map if a new stored name shows up.
const ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  'message-circle': MessageCircle,
  heart: Heart,
  users: Users,
  'file-text': FileText,
  folder: Folder,
  image: Image,
  video: Video,
  music: Music,
  calendar: Calendar,
  tag: Tag,
  bookmark: Bookmark,
  star: Star,
  list: List,
  'layout-grid': LayoutGrid,
  'book-open': BookOpen,
  newspaper: Newspaper,
  mail: Mail,
  link: LinkIcon,
  'map-pin': MapPin,
  package: Package,
  'shopping-cart': ShoppingCart,
  database: Database,
  table: Table2,
};

interface TypeIconProps {
  /** A lucide icon name (kebab-case, e.g. "message-circle") or a short emoji. */
  icon?: string | null;
  className?: string;
  /** Rendered when the icon is empty or unrecognized. */
  fallback?: LucideIcon;
}

export function TypeIcon({ icon, className, fallback: Fallback = Table2 }: TypeIconProps) {
  const key = icon?.trim().toLowerCase();
  if (key) {
    const Icon = ICONS[key];
    if (Icon) return <Icon className={className} />;
    // First char non-ASCII + short = an emoji (the create form labels it "Icon").
    if ((icon!.codePointAt(0) ?? 0) > 127 && [...icon!].length <= 4) {
      return <span className={className}>{icon}</span>;
    }
  }
  return <Fallback className={className} />;
}
